import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { Typography } from "@mui/material";

import { useIsDCIEssentialsTier } from "../../../../Support/hooks/useIsDCIEssentialsTier";
import { AmountInCustomerCurrency } from "../AmountInCustomerCurrency";
import { useIsSupportUser } from "../hooks";
import { LoadingCard } from "../LoadingCard";
import { TopCard } from "../TopCard";

type InsightsCardProps = {
  insightsRisk: number;
  loading: boolean;
};

export const InsightsCard = ({ insightsRisk, loading }: InsightsCardProps) => {
  const isDCIEssencialsCustomer = useIsDCIEssentialsTier();
  const isSupportUser = useIsSupportUser();

  if (loading) {
    return <LoadingCard title="Insights awaiting action" />;
  }

  let subtitle = (
    <Typography variant="caption" sx={{ color: "error.main", ml: 1, display: "flex", alignItems: "center" }}>
      <WarningAmberIcon sx={{ width: 12, height: 12, color: "error.main", mr: 0.25 }} /> Costs at risk per year
    </Typography>
  );

  if (isDCIEssencialsCustomer) {
    subtitle = (
      <Typography variant="caption" color="text.secondary">
        Save <AmountInCustomerCurrency amount={insightsRisk} compactFormat /> a year in cloud costs
      </Typography>
    );
  }

  return (
    <TopCard
      title={isDCIEssencialsCustomer ? "Insights potential savings" : "FinOps Insights"}
      value={insightsRisk}
      dataIcon="warning"
      trend="Costs at risk per year"
      trendColor="error.main"
      disabled={isSupportUser}
      subtitle={insightsRisk > 0 && subtitle}
      items={[
        {
          title: isDCIEssencialsCustomer ? "Learn more about Insights" : "Review and take action",
          path: "./optimize/insights",
          locationState: {
            filterParam: {
              category: "categories",
              value: "FinOps",
            },
          },
          eventName: "FinOps Insights",
          description: "View all insights and recommendations",
        },
      ]}
    />
  );
};
